import axios from "axios";

const axiosClient = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_BASE_URL}/v1`,
});

axiosClient.interceptors.request.use((config) => {
  const token = JSON.parse(sessionStorage.getItem('auth'));

  if (token) {
    config.headers.Authorization = `Bearer ${(token && token?.accessToken) ?? "" }`;
  }
  return config;
}, (error) => Promise.reject(error));

axiosClient.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response && error.response.status === 403) {
    window.location.href = '/';
    sessionStorage.removeItem("auth")
  }
  return Promise.reject(error);
});

export default axiosClient;